// frontend/src/pages/RoleSelectPage.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';

const RoleSelectPage = () => {
  const navigate = useNavigate();

  let displayName = 'Admin';
  let memberId = null;
  try {
    const stored = localStorage.getItem('hopeSaccoUser');
    if (stored) {
      const u = JSON.parse(stored);
      displayName = u.profile?.displayName || u.email || 'Admin';
      memberId = u.profile?.memberId || u.memberId || null;
    }
  } catch {}

  const handleMemberPortal = () => {
    if (!memberId) {
      alert('No member account is linked to your profile. Contact the system administrator to link your member ID.');
      return;
    }
    navigate('/member/dashboard');
  };

  const handleSignOut = () => {
    localStorage.removeItem('hopeSaccoToken');
    localStorage.removeItem('hopeSaccoUser');
    navigate('/login');
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      fontFamily: "'Segoe UI', sans-serif"
    }}>
      <div style={{
        width: '100%',
        maxWidth: '480px',
        animation: 'fadeUp 0.4s ease-out'
      }}>
        <style>{`
          @keyframes fadeUp {
            from { opacity: 0; transform: translateY(24px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .role-card {
            background: rgba(255,255,255,0.04);
            border: 1px solid rgba(255,255,255,0.1);
            border-radius: 16px;
            padding: 20px 24px;
            cursor: pointer;
            transition: all 0.2s ease;
            display: flex;
            align-items: center;
            gap: 18px;
            text-align: left;
            width: 100%;
            color: white;
          }
          .role-card:hover {
            background: rgba(255,255,255,0.09);
            border-color: rgba(255,255,255,0.25);
            transform: translateY(-2px);
            box-shadow: 0 8px 32px rgba(0,0,0,0.3);
          }
          .role-card.primary {
            background: linear-gradient(135deg, rgba(102,126,234,0.3), rgba(118,75,162,0.3));
            border-color: rgba(102,126,234,0.5);
          }
          .role-card.primary:hover {
            background: linear-gradient(135deg, rgba(102,126,234,0.45), rgba(118,75,162,0.45));
            border-color: rgba(102,126,234,0.8);
          }
          .role-card.disabled {
            opacity: 0.45;
            cursor: not-allowed;
          }
          .role-card.disabled:hover {
            transform: none;
            box-shadow: none;
          }
          .icon-wrap {
            width: 52px;
            height: 52px;
            border-radius: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 24px;
            flex-shrink: 0;
          }
        `}</style>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '36px' }}>
          <div style={{
            width: '64px', height: '64px',
            background: 'linear-gradient(135deg, #667eea, #764ba2)',
            borderRadius: '20px',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '28px', margin: '0 auto 20px'
          }}>💰</div>
          <h1 style={{ color: 'white', fontSize: '26px', fontWeight: 700, margin: '0 0 8px' }}>
            Hope SACCO
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '14px', margin: 0 }}>
            Welcome back, <span style={{ color: 'rgba(255,255,255,0.85)', fontWeight: 600 }}>{displayName}</span>
          </p>
        </div>

        {/* Divider label */}
        <p style={{
          color: 'rgba(255,255,255,0.4)',
          fontSize: '11px',
          fontWeight: 600,
          letterSpacing: '1.5px',
          textTransform: 'uppercase',
          textAlign: 'center',
          marginBottom: '16px'
        }}>Choose your dashboard</p>

        {/* Cards */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <button className="role-card primary" onClick={() => navigate('/admin/dashboard')}>
            <div className="icon-wrap" style={{ background: 'rgba(102,126,234,0.3)' }}>🏢</div>
            <div>
              <div style={{ fontWeight: 700, fontSize: '16px', marginBottom: '3px' }}>Admin Dashboard</div>
              <div style={{ color: 'rgba(255,255,255,0.55)', fontSize: '13px' }}>
                Manage members, loans, reports and system settings
              </div>
            </div>
          </button>

          <button
            className={`role-card${!memberId ? ' disabled' : ''}`}
            onClick={handleMemberPortal}
          >
            <div className="icon-wrap" style={{ background: 'rgba(52,211,153,0.15)' }}>👤</div>
            <div>
              <div style={{ fontWeight: 700, fontSize: '16px', marginBottom: '3px' }}>
                Member Portal
                {!memberId && (
                  <span style={{
                    marginLeft: '10px', fontSize: '11px', fontWeight: 600,
                    background: 'rgba(255,255,255,0.1)', borderRadius: '6px',
                    padding: '2px 8px', color: 'rgba(255,255,255,0.4)'
                  }}>No account linked</span>
                )}
              </div>
              <div style={{ color: 'rgba(255,255,255,0.55)', fontSize: '13px' }}>
                {memberId
                  ? 'View your personal account, loans and statements'
                  : 'No member ID is linked to your profile'}
              </div>
            </div>
          </button>
        </div>

        {/* Sign out */}
        <div style={{ textAlign: 'center', marginTop: '28px' }}>
          <button onClick={handleSignOut} style={{
            background: 'none', border: 'none',
            color: 'rgba(255,255,255,0.3)', fontSize: '13px',
            cursor: 'pointer', transition: 'color 0.2s'
          }}
          onMouseOver={e => e.target.style.color = 'rgba(255,255,255,0.6)'}
          onMouseOut={e => e.target.style.color = 'rgba(255,255,255,0.3)'}
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
};

export default RoleSelectPage;
